
    
import { Component, Prop, Vue } from 'vue-property-decorator';
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

@Component({
    components:{
        CheckBox
    }
})
export default class ArrangeForServiceCmPpmRelocEnfrcInstructions extends Vue {    

    @Prop({required: true})
    instructionsStep!: string;

    @Prop({required: true})
    applicationName!: string;
    
}
